import { Breadcrumbs, Link, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Icon, { type IconName } from 'components/Icon'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import { muiTheme } from 'mui-theme'

import type { UserDefinedService } from 'types/api/services/service'

type BreadcrumbListItem = {
  href: string
  icon?: IconName
  label: string
}

/**
 * Builds a list of breadcrumbs when redirecting from Service Settings. This is necessary because MUI's Breadcrumbs
 * component does not accept a fragment as a child.
 *
 * @param serviceId
 * @param serviceName
 * @param referrer
 */
function getServiceSettingsStatusCheckBreadcrumbs(
  serviceId,
  serviceName,
  referrer
): BreadcrumbListItem[] {
  return [
    { href: '/services', icon: 'chartNetwork', label: 'Services' },
    { href: `/services/${serviceId}`, label: serviceName },
    { href: referrer, label: 'Settings' }
  ]
}

export const StatusCheckBreadcrumbs: React.FC<{
  referrer: string
  service?: UserDefinedService
  endLabel: string
}> = ({ referrer, service, endLabel }) => {
  const statusChecksUrls = getStatusChecksUrls()

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {service?.serviceId ? (
        getServiceSettingsStatusCheckBreadcrumbs(
          service.serviceId,
          service.name,
          referrer
        ).map(({ href, icon, label }, index) => (
          <Link key={index} component={RouterLink} to={href} underline="hover">
            {icon && (
              <Icon css={{ marginRight: muiTheme.spacing(1) }} icon={icon} />
            )}
            {label}
          </Link>
        ))
      ) : (
        <Link
          data-test-status-check-back-link
          component={RouterLink}
          to={referrer === '/' ? statusChecksUrls.base() : referrer}
          underline="hover"
        >
          <Icon css={{ marginRight: muiTheme.spacing(1) }} icon="wavePulse" />
          Health Checks
        </Link>
      )}
      <Typography color="text.primary">{endLabel}</Typography>
    </Breadcrumbs>
  )
}
